import React, { useEffect, lazy } from "react"
import connect from "react-redux/es/connect/connect";
import bindActionCreators from "redux/src/bindActionCreators";
import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/Button";
import {closeShopifyCart, removeShopifyCartItemBulk} from "./components/actionCreators/shopifyAC";
import PromoMessages from "./components/PDP/Columns/PromoMessages";
import {getPromoMessages} from "./components/actionCreators/appAC";
import InlineSpinner from "./components/common/InlineSpinner";

const CartContainer = (props) => {
    const Cart = lazy(() => import('./components/cartb'));

    useEffect(() => {
        props.getPromoMessages();
    }, [])

    const dismissCart = (is_cart_busy = false) => {
        if (!is_cart_busy) {
        document.querySelector(".cart-popup > .modal-dialog").classList.remove("cart-animation");
        setTimeout(function () {
            props.closeShopifyCart();
            }, 400);
        }
    }

    const {
        mobile_big, promo_messages, cart_count, isCartOpen, item_added_to_cart, checkout,
        removeShopifyCartItemBulk, user_profile, is_cart_busy
    } = props;
    const trade_in_bags = sessionStorage.getItem("trade_in_bags") ? JSON.parse(sessionStorage.getItem("trade_in_bags")) : [];
    const trade_in_bags_count = trade_in_bags.length;

    if(!isCartOpen){
        return null;
    }

    return (
        <Modal
            show={true}
            centered
            onHide={() => dismissCart(is_cart_busy)}
            className={`cart-popup ${cart_count === 0 && trade_in_bags_count === 0 ? "cart-popup--empty" : ""}`}
            container={document.getElementById('react-popup-container')}
            backdropClassName="dark-overlay"
        >
            {is_cart_busy &&
            <InlineSpinner
                custom_class="inline-spinner-container"
            />
            }
            {promo_messages && promo_messages.length > 0 &&
            <div className={`cart-popup__promo-messaging ${promo_messages.length > 1 ? "promo-messaging-carousel" : ""}`}>
                <PromoMessages
                    promo_messages={promo_messages}
                />
            </div>
            }
            <Modal.Header className="cart-popup__header">
                <Modal.Title
                    as={"h4"}
                    className="cart-popup__title"
                >
                    {(cart_count > 0 || trade_in_bags_count > 0) ? "Your Cart" : ""}
                </Modal.Title>
                {user_profile && user_profile.is_b2b && cart_count > 0 &&
                <Button
                    onClick={() => removeShopifyCartItemBulk(checkout.lineItems)}
                    className="cart-row__clyde-remove-btn"
                    variant="clean"
                >
                    Clear Entire Cart
                </Button>
                }
                <Button
                    className="cart-popup__close-icon"
                    onClick={() => dismissCart(is_cart_busy)}
                    variant="clean"
                    aria-label="Close"
                >
                    <span className="icon-close"/>
                </Button>
            </Modal.Header>
            <Modal.Body>
                <Cart
                    is_in_checkout={false}
                    mobile={mobile_big}
                    item_added_to_cart={item_added_to_cart}
                />
            </Modal.Body>
        </Modal>
    )
}

const mapStateToProps = function (state) {
    const { mobile_big, promo_messages } = state.appReducer;
    const { cart_count, isCartOpen, item_added_to_cart, checkout, is_cart_busy } = state.shopifyReducer;
    const { user_profile } = state.myAccountReducer;
    return {mobile_big, promo_messages, cart_count, isCartOpen, item_added_to_cart, checkout, user_profile, is_cart_busy};
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        closeShopifyCart,
        removeShopifyCartItemBulk,
        getPromoMessages
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CartContainer);
